import React from 'react';
import { Preloader } from '@wix/wix-base-ui';
import styles from './privateAppsPanel.scss';
import { AppDetails } from './components/appDetails/appDetails';
import EmptyPrivateAppsPanel from './components/EmptyState/EmptyState';
import AppVersionsList from './components/AppVersionsList/AppVersionsList';
import {
  ListView,
  usePrivateApps,
} from './components/privateAppsProvider/privateAppsProvider';
import { PrivateAppsLists } from './components/privateAppsLists/privateAppsLists';

// If you come here to rewrite "Private Apps" panel from scratch
// Pretty quickly you may come to the question: "All these properties for app version, is this a joke?"
// The answer is: "Stay strong, believe in yourself and never give up!".
// Here are some hints:
// 1. "app.version"                    -- version of the app at the moment of installation; always major; may be missing
// 2. "app.appFields.installedVersion" -- version of the app at the moment of installation; semantic;     may be missing
// 3. "app.appFields.semanticVersion"  -- current version of the app on a site;             semantic;     always present
// 4. Test version of the app has "latest" value in "version" and "installedVersion" fields
// 5. "app.latestVersion"              -- latest available version of the app;
//       -- test only not installed version has value of "0.0.0"
//       -- test only installed version has value of "" (empty string)
const PrivateAppsPanel: React.FC = () => {
  const { installedApps, availableApps, isLoading, selectedListView } =
    usePrivateApps();

  const LeftContainer = React.useMemo(
    // eslint-disable-next-line react/display-name
    () => () =>
      selectedListView === ListView.AppVersions ? (
        <AppVersionsList />
      ) : (
        <PrivateAppsLists />
      ),
    [selectedListView],
  );

  if (isLoading) {
    return (
      <div className={styles.loaderContainer}>
        <Preloader className={'medium'} />
      </div>
    );
  }

  if (availableApps.length === 0 && installedApps.length === 0) {
    return <EmptyPrivateAppsPanel />;
  }

  return (
    <div className={styles.privateAppsContainer} data-hook="private-apps-panel">
      <div className={styles.leftContainer}>
        <LeftContainer />
      </div>
      <div className={styles.rightContainer}>
        <AppDetails />
      </div>
    </div>
  );
};

export default PrivateAppsPanel;
